import { render, staticRenderFns } from "./OButton.vue?vue&type=template&id=78700a5f&"
import script from "./OButton.vue?vue&type=script&lang=js&"
export * from "./OButton.vue?vue&type=script&lang=js&"
import style0 from "./OButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports